import React, { Component } from "react";
import Cookies from "universal-cookie";
import { Modal, Form, Input, Select, Upload, Button, Row, Col, Image } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { uploadDocumentService } from "../../services/UploadDocumentService";

const { Option } = Select;

class ModalHandoverDocument extends Component {
  user = new Cookies().get("_bbn_un");

  constructor(props) {
    super(props);

    const isMultiOrder = Array.isArray(props?.dataOrder) && props.dataOrder.length > 1;
    const engineNumbers = isMultiOrder ? props.dataOrder.map((order) => order.vehicle_engine_number).join(", ") : props?.dataOrder?.[0]?.vehicle_engine_number || "";

    this.state = {
      loadingButton: false,
      isMultiOrder: isMultiOrder,
      inputEngineNumber: engineNumbers,
      inputDocumentType: null,
      inputDocumentNumber: "",

      inputImage: [],
      validImage: false,
      inputImagePreview: "",
    };
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.dataOrder;
    const curr = this.props.dataOrder;
    const prevVisible = prevProps.visible;
    const currVisible = this.props.visible;

    // Handle both single and multi order updates
    const prevKey = Array.isArray(prev) ? prev.map((order) => order.vehicle_engine_number).join(",") : prev?.vehicle_engine_number;

    const currKey = Array.isArray(curr) ? curr.map((order) => order.vehicle_engine_number).join(",") : curr?.vehicle_engine_number;

    // Update when data changes OR when modal becomes visible
    if ((curr && prevKey !== currKey) || (!prevVisible && currVisible && curr)) {
      const isMultiOrder = Array.isArray(curr) && curr.length > 1;
      const engineNumbers = isMultiOrder ? curr.map((order) => order.vehicle_engine_number).join(", ") : curr?.[0]?.vehicle_engine_number || "";

      this.setState({
        loadingButton: false,
        isMultiOrder: isMultiOrder,
        inputEngineNumber: engineNumbers,
        inputDocumentType: null,
        inputDocumentNumber: "",
        inputImage: [],
      });
    }
  }

  handleCloseModal = () => {
    this.setState({
      loadingButton: false,
      inputEngineNumber: "",
      inputDocumentType: null,
      inputDocumentNumber: "",
      inputImagePreview: null,
      inputImage: [],
    });

    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  beforeUploadFile = (file) => {
    const isImage = file.type.startsWith("image/");

    if (!isImage) {
      Modal.error({
        title: "Validation Error",
        content: "Format File Bukan Image",
      });
    }

    if (isImage) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.setState({
          inputImage: file,
          inputImagePreview: event.target.result,
          validImage: true,
        });
      };

      reader.readAsDataURL(file);
    } else {
      this.setState({
        validImage: false,
      });
    }
    return false;
  };

  handleFieldChange = (field, value) => {
    const { dataOrder } = this.props;
    const { isMultiOrder } = this.state;

    if (field === "inputDocumentType") {
      if (!isMultiOrder && dataOrder && dataOrder.length > 0) {
        // Auto-fill for single order mode - access first element of array
        const singleOrder = dataOrder[0];
        let docNumber = "";
        switch (value) {
          case "pelat":
            docNumber = singleOrder.vehicle_license_plate || "";
            break;
          case "notice":
            docNumber = singleOrder.vehicle_notice_number || "";
            break;
          case "stnk":
            docNumber = singleOrder.vehicle_registration_certificate_number || "";
            break;
          case "bpkb":
            docNumber = singleOrder.vehicle_certificate_of_ownership_number || "";
            break;
          default:
            docNumber = "";
            break;
        }

        this.setState({ inputDocumentNumber: docNumber });
      } else if (isMultiOrder) {
        // For multi-order, use document type as document number
        this.setState({ inputDocumentNumber: value });
      }
    }

    this.setState({ [field]: value });
  };

  onHandoverDocument = async () => {
    const currentState = { ...this.state };
    const { dataOrder } = this.props;
    const { isMultiOrder } = this.state;

    if (!currentState.inputEngineNumber) {
      Modal.error({ title: "Error", content: "Invalid Nomor Mesin" });
      return;
    }
    if (!currentState.inputDocumentType) {
      Modal.error({ title: "Error", content: "Invalid Tipe Dokumen" });
      return;
    }
    // Only validate document number for single order mode
    if (!isMultiOrder && !currentState.inputDocumentNumber) {
      Modal.error({ title: "Error", content: "Invalid Nomor Dokumen" });
      return;
    }

    this.setState({ loadingButton: true });

    const formData = new FormData();
    // For multi-order, send comma-separated engine numbers
    formData.append("vehicle_engine_number", currentState.inputEngineNumber.replace(", ", ","));
    formData.append("document_type", currentState.inputDocumentType);
    // For multi-order, use document type as document number, for single order use inputDocumentNumber
    formData.append("document_number", isMultiOrder ? currentState.inputDocumentType : currentState.inputDocumentNumber);
    formData.append("document_image", currentState.inputImage);
    formData.append("updated_by", atob(this.user));

    try {
      await uploadDocumentService.uploadHandoverDocument(formData).then((result) => {
        Modal.success({
          title: "Proses Sukses",
          content: result?.data?.message,
        });

        // Prepare updated data for callback
        const currentDate = new Date().toISOString().slice(0, 10);

        if (isMultiOrder) {
          // Multi handover - return updated array of orders
          const updatedOrders = dataOrder.map((order) => ({
            ...order,
            // Update submission dates based on document type
            ...(currentState.inputDocumentType === "stnk" && {
              vehicle_registration_certificate_submission_date: currentDate,
            }),
            ...(currentState.inputDocumentType === "bpkb" && {
              vehicle_certificate_of_ownership_submission_date: currentDate,
            }),
            ...(currentState.inputDocumentType === "notice" && {
              vehicle_notice_submission_date: currentDate,
            }),
          }));

          if (this.props.onSaveData) {
            this.props.onSaveData(updatedOrders);
          }
        } else {
          // Single handover - return updated single order (first element of array)
          const updatedOrder = {
            ...dataOrder[0],
            // Update submission dates based on document type
            ...(currentState.inputDocumentType === "stnk" && {
              vehicle_registration_certificate_submission_date: currentDate,
            }),
            ...(currentState.inputDocumentType === "bpkb" && {
              vehicle_certificate_of_ownership_submission_date: currentDate,
            }),
            ...(currentState.inputDocumentType === "notice" && {
              vehicle_notice_submission_date: currentDate,
            }),
          };

          if (this.props.onSaveData) {
            this.props.onSaveData(updatedOrder);
          }
        }

        this.handleCloseModal();
      });
    } catch (e) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e.message,
      });
      this.setState({
        loadingButton: false,
      });
    }
  };

  render() {
    const { inputDocumentType, inputEngineNumber, inputDocumentNumber, loadingButton, isMultiOrder } = this.state;
    const { dataOrder } = this.props;

    const modalTitle = isMultiOrder ? `Multi Handover Dokumen (${Array.isArray(dataOrder) ? dataOrder.length : 0} Order)` : "Handover Dokumen";

    return (
      <Modal
        title={modalTitle}
        open={this.props.visible}
        onCancel={this.handleCloseModal}
        closable={false}
        keyboard={false}
        maskClosable={false}
        footer={[
          <Button key="submit" type="primary" onClick={this.onHandoverDocument} loading={loadingButton}>
            {isMultiOrder ? "Simpan Multi Bukti" : "Simpan Bukti"}
          </Button>,
          <Button key="close" onClick={this.handleCloseModal} loading={loadingButton}>
            Tutup
          </Button>,
        ]}
      >
        <Row gutter={16}>
          <Col xs={{ span: 24 }} xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }}>
            <Form layout="vertical">
              <Row gutter={16}>
                {!isMultiOrder && (
                  <Col xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }}>
                    <Form.Item label="Nomor Mesin">
                      <Input value={inputEngineNumber} disabled />
                    </Form.Item>
                  </Col>
                )}
                <Col xs={{ span: 24 }} xl={{ span: isMultiOrder ? 24 : 12 }} lg={{ span: isMultiOrder ? 24 : 12 }} md={{ span: 24 }} sm={{ span: 24 }}>
                  <Form.Item label="Tipe Dokumen" required>
                    <Select placeholder="Pilih Tipe Dokumen" value={inputDocumentType} onChange={(value) => this.handleFieldChange("inputDocumentType", value)}>
                      <Option value="pelat">PELAT</Option>
                      <Option value="notice">NOTICE</Option>
                      <Option value="stnk">STNK</Option>
                      <Option value="bpkb">BPKB</Option>
                    </Select>
                  </Form.Item>
                </Col>
                {!isMultiOrder && (
                  <Col xs={{ span: 24 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }}>
                    <Form.Item label="Nomor Dokumen">
                      <Input value={inputDocumentNumber} disabled />
                    </Form.Item>
                  </Col>
                )}
                <Col xs={{ span: 24 }} xl={{ span: isMultiOrder ? 24 : 12 }} lg={{ span: isMultiOrder ? 24 : 12 }} md={{ span: 24 }} sm={{ span: 24 }}>
                  <Form.Item label="Upload Bukti">
                    <Upload maxCount={1} showUploadList={false} beforeUpload={this.beforeUploadFile}>
                      <Button icon={<UploadOutlined />} loading={loadingButton} style={{ width: "100%" }}>
                        Select File
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>

          <Col xs={{ span: 24 }} xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }}>
            <br />
            {this.state.inputImagePreview && (
              <Form.Item>
                <Image width={"inherit"} src={this.state.inputImagePreview} />
              </Form.Item>
            )}
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default ModalHandoverDocument;
